import React from "react";
import PropTypes from "prop-types";

import TicketSelector from "./TicketSelector";
import CheckboxElement from "./Checkbox";

import FormSection from "ui/FormSection";

import DialogContent from "@mui/material/DialogContent";
import Divider from "@mui/material/Divider";

const Content = ({ availableTickets, availableProducts = [], ticketIds, onTicketCheckboxChange, itemNoun = "ticket" }) => {
  const hasTickets = availableTickets.length > 0;
  const hasProducts = availableProducts.length > 0;

  const getModalContent = () => {
    if (!hasTickets && !hasProducts) {
      return (
        <FormSection slim>
          <p>No {itemNoun}s available</p>
        </FormSection>
      );
    }

    // single item in single event
    if (!hasProducts && availableTickets.length === 1 && !availableTickets[0].sessionTitle) {
      return (
        <FormSection slim>
          <p>Are you sure you want to end the sale of the {itemNoun} <strong>{availableTickets[0].identifier}</strong>?</p>
        </FormSection>
      );
    }

    // single ticket in event with sessions
    if (!hasProducts && availableTickets.length === 1 && availableTickets[0].sessionTitle && availableTickets[0].tickets.length === 1) {
      return (
        <FormSection slim>
          <p>Are you sure you want to end the sale of the {itemNoun} <strong>{availableTickets[0].tickets[0].identifier}</strong> for the session happening on ${availableTickets[0].sessionTitle}?</p>
        </FormSection>
      );
    }

    const selectionNoun = hasTickets && hasProducts ? "item" : hasProducts ? "product" : itemNoun;

    // multiple items, split into ticket and product groups when both exist
    return (
      <>
        <p>Please select the {selectionNoun}s you want to end the sale of:</p>

        {hasTickets && (
          <div style={{ marginBottom: hasProducts ? "1rem" : 0 }}>
            {hasProducts && <strong>Tickets</strong>}
            <TicketSelector
              availableTickets={availableTickets}
              ticketIds={ticketIds}
              onTicketCheckboxChange={onTicketCheckboxChange}
            />
          </div>
        )}

        {hasTickets && hasProducts && <Divider sx={{ marginBottom: "1rem" }} />}

        {hasProducts && (
          <div>
            {hasTickets && <strong>Products</strong>}
            {availableProducts.map((product) => (
              <CheckboxElement
                key={product.id}
                ticket={product}
                ticketIds={ticketIds}
                onTicketCheckboxChange={onTicketCheckboxChange}
              />
            ))}
          </div>
        )}
      </>
    );
  };

  return (
    <DialogContent dividers>
      {getModalContent()}
    </DialogContent>
  );
};

Content.propTypes = {
  availableTickets: PropTypes.array,
  availableProducts: PropTypes.array,
  ticketIds: PropTypes.array,
  onTicketCheckboxChange: PropTypes.func,
  itemNoun: PropTypes.string
};

export default Content;
